import { Button, Form, Input, InputNumber, message, Modal } from 'antd'
import { useForm } from 'antd/es/form/Form'
import React, { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { MyValidateMessages } from '../../../../utils/validateMessaage'
import { changeHousePriority } from '../../../../api/api'
const ChangePriority = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [form] = useForm()
  const showModal = () => {
    setIsModalOpen(true)
  }
  const { id, setIsFresh } = props
  const handleOk = () => {
    const val = form.getFieldValue('priority')
    changeHousePriority(id, val).then((res) => {
      console.log(res)
      message.success('修改优先级成功')
      setIsFresh(pre => !pre)
    }).catch(err => {
      console.log(err);
      message.err('修改优先级失败')
    })

    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  }
  return (
    <>
      <a type="primary" onClick={showModal}>
        优先级{' '}
      </a>

      <Modal
        title="修改优先级"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
        >
          <Form.Item label="优先级" name="priority">
            <InputNumber
              min={0}
              max={99}
              style={{ width: '330px' }}
              placeholder="0-99的整数"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
export default ChangePriority
